import Footer from "./components/Footer";
import Header from "./components/Header";
import SubHeader from "./components/SubHeader";
import Blog from "./page/Blog";
import Courses from "./page/Courses";
import Home from "./page/Home";
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import Error from "./components/Error";
import Tutorial from "./page/Tutorial";
import Notes from "./page/Notes";
import Contact from "./page/Contact";
import WorkWithUs from "./page/WorkWithUs";
import Login from "./page/Login";
import SignUp from "./page/SignUp";
import Admin from "./page/Admin";

const Body = () => {
	return (
		<div className=" w-full h-full">
			<div className="fixed z-50 w-full">
				<Header />
			</div>
			<div className="h-20 w-full"></div>
			<SubHeader />
			<Outlet />
			<Footer />
		</div>
	);
};

const router = createBrowserRouter([
	{
		path: "/",
		element: <Body />,
		children: [
			{
				path: "/",
				element: <Home />,
			},
			{
				path: "/courses",
				element: <Courses />,
			},
			{
				path: "/tutorial",
				element: <Tutorial />,
			},
			{
				path: "/blog",
				element: <Blog />,
			},
			{
				path: "/notes",
				element: <Notes />,
			},
			{
				path: "/contact",
				element: <Contact />,
			},
			{
				path: "/work-with-us",
				element: <WorkWithUs />,
			},
			{
				path: "/logIn",
				element: <Login />,
			},
			{
				path: "/signUp",
				element: <SignUp />,
			},
			{
				path: "/admin",
				element: <Admin />,
			},
			{ path: "*", element: <Error /> },
		],
	},
]);
const App = () => {
	return (
		<div>
			<RouterProvider router={router} />
		</div>
	);
};

export default App;
